import { Component, EventEmitter, Input, NO_ERRORS_SCHEMA, OnChanges, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators, ValidatorFn } from '@angular/forms';
import _ = require('lodash');
import { isNullOrUndefined } from 'util';
import { Claim } from '../../../models/claim.model';
import { Remittance } from '../../../models/remittance.model';
import { AuthorizationService } from '../../../services/authorization.service';
import { CURRENCY_PATTERN, EventSearchApplicationHelper } from '../helpers/event-search.applicationHelper';

@Component({
  selector: 'app-eventsearch-manualapplication',
  templateUrl: './eventsearch-manualapplication.component.html',
  styleUrls: ['./eventsearch-manualapplication.component.css'],
})

export class EventSearchManualApplicationComponent implements  OnChanges {
  @Input() manualApplicationModal: boolean;
  @Output() manualApplicationModalChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() selectedClaim: Claim;
  @Input() selectedRemittance: Remittance;
  @Output() onModalAction: EventEmitter<any> = new EventEmitter<any>();

  readonly applicationHelper: EventSearchApplicationHelper;
  public manualApplicationForm: FormGroup;
  public unappliedAmount = 0;
  public applyAmount = 0;

  constructor(private authorizationService: AuthorizationService, private fb: FormBuilder) {
    this.applicationHelper = new EventSearchApplicationHelper(this.authorizationService)
    this.initManualApplicationForm();
  }

  ngOnChanges(): void {
    if (this.selectedRemittance) {
      this.applyAmount = this.selectedRemittance.AREngine_UnappliedAmount
      this.unappliedAmount = this.selectedRemittance.AREngine_UnappliedAmount
    }
  }

  valueInRange(value: number): boolean {
    let val = Math.abs(_.round(value, 2)) > Math.abs(_.round(this.unappliedAmount, 2)) ? false : true;
    return val;
  }

  isValidEntry(currentMax: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (isNullOrUndefined(control.value)) {
        return null;
      }
      let roundedVal = _.round(control.value, 2);
      if (roundedVal === 0 || !this.valueInRange(roundedVal)) {
         return { greaterThanRemainingBalance: true }
      }
      if (this.applyAmount < 0 && control.value > 0) {
        return { negativeValueOnly: true }
      };
      if (this.applyAmount > 0 && control.value < 0) {
        return { positiveValueOnly: true }
      }
      return null
    }
  }

  cancelClick() {
    this.manualApplicationForm.reset();
    this.resetData();
    this.manualApplicationModal = false;
    this.manualApplicationModalChange.emit(this.manualApplicationModal);
    this.onModalAction.emit({ type: 'cancel' })
  }

  resetData(): void {
    this.unappliedAmount = this.selectedRemittance.AREngine_UnappliedAmount
    this.applyAmount = this.unappliedAmount
  }

  submitClick() {
    this.applyAmount = this.manualApplicationForm.controls['applyAmount'].value
    this.onModalAction.emit({ type: 'submit', value: this.applyAmount })
  }

  initManualApplicationForm(eventId?: string): void {
    this.manualApplicationForm = this.applicationHelper.buildApplicationForm(this.fb, CURRENCY_PATTERN,
      this.isValidEntry(this.unappliedAmount))
  };
}



// WEBPACK FOOTER //
// ./src/app/components/event-search/eventsearch-manualapplication/eventsearch-manualapplication.component.ts